<template>
    <label class="label block text-lg font-semibold">
        <slot></slot>
    </label>
</template>
